import { ProductTypeEnum, StoreImageEnum, StoreItemEnum } from '@systemeio/digital-store-shared'
import { StoreItemWithTabType } from '../types/store-item-interface'

type ArgsType =
  | {
      itemType: Exclude<StoreItemWithTabType, StoreItemEnum.product>
      productType?: never
    }
  | {
      itemType: Extract<StoreItemWithTabType, StoreItemEnum.product>
      productType: ProductTypeEnum
    }

type FunctionType = (args: ArgsType) => StoreImageEnum

export const getImageTypeFromItem: FunctionType = ({ itemType, productType }) => {
  if (itemType === StoreItemEnum.product) {
    switch (productType) {
      case ProductTypeEnum.download:
        return StoreImageEnum.product_download_thumbnail
      case ProductTypeEnum.eCourse:
        return StoreImageEnum.e_course_thumbnail
      case ProductTypeEnum.physicalProduct:
        return StoreImageEnum.physical_product_thumbnail
      default:
        throw new Error()
    }
  }

  switch (itemType) {
    case StoreItemEnum.link:
      return StoreImageEnum.link_thumbnail
    case StoreItemEnum.optin:
      return StoreImageEnum.optin_thumbnail
    default:
      throw new Error()
  }
}
